import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import LockIcon from '@mui/icons-material/Lock';
import { Box, Typography } from '@mui/material';
import { TextInput } from 'shared/components/Form/TextInput';
import { Controller, useFormContext } from 'react-hook-form';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';

export const TournamentAsyncPassphraseBlock: FC = () => {
  const isPrivateTournament = useSelector(currentTournamentSelector.isPrivateTournament);
  const formContext = useFormContext();
  const control = formContext?.control;

  if (!isPrivateTournament || !control) {
    return null;
  }

  return (
    <Controller
      name="passphrase"
      control={control}
      render={({ field: { ...rest }, fieldState: { error } }) => (
        <Box mb={2} width="100%">
          <Box display="flex">
            <Typography mb={1} pr={1}>
              Enter tournament passphrase:
            </Typography>
          </Box>
          <TextInput
            {...rest}
            type="password"
            startIcon={<LockIcon />}
            placeholder="Passphrase"
            error={Boolean(error)}
          />
        </Box>
      )}
    />
  );
};
